
// engine
import { appDispatcher, currencyService, delay, gameDispatcher, screenDispatcher } from '@aceroll/core';

// hacksaw
import dataActionType from '../platform/constants/data-action-type';
import { gameSoundService } from './game-sound-service';

const SYMBOL_ID_FS = '11';

class WinAnimationService {
	#isWinCycle = false;
	constructor() {
		this.stopWinCycle = this.stopWinCycle.bind(this);
	}

	async playEvent(serverEvent) {
		const { data } = serverEvent;
		const actions = data.actions;


		await this.playActions(actions.filter((action) => { return action.type === dataActionType.BONUS }));
		await this.playActions(actions.filter((action) => { return action.type === dataActionType.GRID_WIN && action.data.symbol === SYMBOL_ID_FS }));

		// Multiplier animation should be played before the total win animation because the multipliers are included to total win
		const playableActions = actions.filter((action) => {
			return action.type === dataActionType.ADD ||
				action.type === dataActionType.MULTIPLY ||
				action.type === dataActionType.EPIC_ADD ||
				action.type === dataActionType.EPIC_MULTIPLIY
		});

		await this.playParallelActions(playableActions, 200);

		const expandActions = actions.filter((action) => { return action.type === dataActionType.EXPAND });
		const gridWinActions = actions.filter((action) => { return action.type === dataActionType.GRID_WIN });

		// play all expands in parallel with smal delay between
		await this.playParallelActions(expandActions, 180);

		// Replace grid win positions which are in the expanded reel by the position of expanded wild
		// to make wild animate during the gridwin animation.
		this.#extendGridWinsByExpands(expandActions, gridWinActions);

		await this.playTotalWin(serverEvent);
	}

	async playActions(actions) {
		if (!actions || !actions.length) {
			return Promise.resolve();
		}

		for (let i = 0; i < actions.length; i++) {
			const action = actions[i];
			await this.playAction(action);
		}
	}

	async playParallelActions(actions, delayMs) {
		if (!actions || !actions.length) {
			return Promise.resolve();
		}
		const all = [];
		for (let i = 0; i < actions.length; i++) {
			const action = actions[i];
			all.push(delay(delayMs * i).then(() => { return this.playAction(action); }));
		}
		return Promise.all(all);
	}

	async playAction(action) {
		// console.log(`playAction: ${action.type}`, action.data);
		switch (action.type) {
			case dataActionType.GRID_WIN:
				return this.#playGridWin(action.data);
			case dataActionType.BONUS:
				return this.#playFeatureBonus(action.data);
			case dataActionType.ADD:
			case dataActionType.MULTIPLY:
			case dataActionType.EPIC_ADD:
			case dataActionType.EPIC_MULTIPLIY:
				return this.#playMultiplier(action);
			case dataActionType.EXPAND:
				return this.#playExpand(action.data);
			default:
				console.log(`ACTION [${action}] IS NOT CONFIGURED`);
				return Promise.resolve();
		}
	}

	updateMultipliersPanel(values) {
		const { multiplierPanel } = appDispatcher.state.app.currentLayout;

		for (let i = 0; i < values.length; i++) {
			const value = values[i];
			multiplierPanel.setValue(i, value);
		}
	}

	async playTotalWin(serverEvent) {
		const { win, data } = serverEvent;
		const actions = data.actions;

		const { slotMachine, bigWinPopup, totalWin } = appDispatcher.state.app.currentLayout;

		const lines = actions.filter((action) => {
			// FS symbol(11) is also in grediWin, but winAmount is 0
			// return action.type === 'gridwin' && action.data.winAmount > 0;

			// show all gridwins including FS symbols
			return action.type === 'gridwin';
		});

		function mergePositions(lines) {
			let positions = [];

			for (let i = 0; i < lines.length; i++) {
				positions.push(...lines[i].data.positions);
			}

			positions = positions.sort((a, b) => a.reel - b.reel);

			const uniquePositions = [...new Set(positions.map(p => `${p.reel}-${p.row}`))].map(p => {
				const res = {
					reel: +[p[0]],
					row: +[p[2]]
				};

				return res;
			});

			return uniquePositions;
		}

		if (win) {
			// const lineIds = lines.map((gridWin) => {
			//     const line = gridWin.data.line;
			//     // winLines.play(line);
			//     return line;
			// });
			const positions = mergePositions(lines)
			const winMult = win / gameDispatcher.state.bet;

			if (winMult < 20) {
				soundService.play('regular_total_win');
				await Promise.all([
					slotMachine.playWin(positions), // animate all won symbols
					totalWin.show(win)
				]);
				totalWin.hide();
			} else {
				gameSoundService.playLevelAmbient(2);
				await Promise.all([
					slotMachine.playWin(positions), // animate all won symbols
					bigWinPopup.show(gameDispatcher.state.bet, win)
				]);
				
			}
			slotMachine.grid.stop();
		}
	}

	async #playMultiplier(action) {
		const { data } = action;
		const { total } = data;
		const { slotMachine } = appDispatcher.state.app.currentLayout;


		// first animate the symbol at the position
		await slotMachine.playMultiplier(action);

		this.updateMultipliersPanel(total);
	}

	// async #playWinLine(data) {
	//     const slotMachine = appDispatcher.state.app.currentLayout.slotMachine;
	//     const { winAmount, baseWinAmount, count, symbol, positions } = data;
	//     await slotMachine.playWin(positions);
	// }

	async #playExpand(data) {
		const { slotMachine } = appDispatcher.state.app.currentLayout;
		const { multiplier, position } = data;

		await slotMachine.expand(position, multiplier);
		this.updateMultipliersPanel(data.reelMultipliers);

		//TODO update multiplier value on the expand symbols

	}

	async #playGridWin(data) {
		const { slotMachine, winLines } = appDispatcher.state.app.currentLayout;
		const { positions, line } = data;
		// winLines.play(line);
		await slotMachine.playWin(positions);
		// winLines.stop(line);
	}

	// async #playFeatureRespin(data) {
	//     if (!data) {
	//         return Promise.resolve();
	//     }
	//
	//     const { multiplierPanel, slotMachine } = appDispatcher.state.app.currentLayout;
	//
	//     const { count } = data;
	//
	//     // debug DB
	//     // if (responseService.currentFeature === 'bonus_1') {
	//     //     multiplierPanel.showBonus(1, false);
	//     // } else {
	//     //     multiplierPanel.showBase(1);
	//     // }
	//
	//     return await slotMachine.playRespinTrigger(data, count);
	// }

	async #playFeatureBonus() {
		const { background } = appDispatcher.state.app.currentLayout;

		// don't need to wait. Now it plays in parallel with FS symbols animation
		background.playAction();
	}

	async playWinCycle(serverEvent, iterations = 1) {
		const { data } = serverEvent;
		const actions = data.actions;
		const gridWins = actions.filter((action) => { return action.type === dataActionType.GRID_WIN && action.data.symbol !== SYMBOL_ID_FS });
		const { slotMachine, winLines } = appDispatcher.state.app.currentLayout;

		if (!gridWins || !gridWins.length) { return; }

		const length = gridWins.length;
		let index = 0;
		this.#isWinCycle = true;

		screenDispatcher.onScreenClick(this.stopWinCycle);

		let cycles = 0;

		do {
			const gridWin = gridWins[index].data;
			const symbolId = gridWin.symbol;
			winLines.play(gridWin.line);
			// slotMachine.grid.showWinFormulaText('8888');
			const win = currencyService.toCurrency(gridWin.winAmount);

			const { totalWin } = serverEvent;
			const { bet } = gameDispatcher.state;

			slotMachine.sounds.playWinLine({ symbolId, cheap: totalWin <= bet });
			slotMachine.grid.repositionWinText(gridWin.positions);
			slotMachine.grid.showWinText(win, 1600, 0);
			await slotMachine.playWin(gridWin.positions);
			winLines.stop(gridWin.line);
			const newIndex = index + 1;
			if (newIndex >= length) {
				cycles++;
			}
			index = newIndex % length;
		} while (this.#isWinCycle && cycles < iterations)

		this.stopWinCycle();
	}

	stopWinCycle() {
		const { slotMachine } = appDispatcher.state.app.currentLayout;

		screenDispatcher.offScreenClick(this.stopWinCycle);
		this.#isWinCycle = false;
		slotMachine.grid.stop();
	}

	/**
	 * Will change the gridWins, replacing corresponding symbols to the expanded wild position. Which
	 * make the wild symbol animating during the gridWin animation.
	 * @param {Array} expands array of actions
	 * @param {Array} gridWins array of actions
	 * @returns
	 */
	#extendGridWinsByExpands(expands, gridWins) {
		if (!expands || !expands.length) { return; }
		if (!gridWins || !gridWins.length) { return; }

		for (let i = 0; i < expands.length; i++) {
			const expand = expands[i];
			const expandPosition = expand.data.position;

			for (let j = 0; j < gridWins.length; j++) {
				const gridWin = gridWins[j];
				const winPositions = gridWin.data.positions;
				if (!winPositions[expandPosition.reel]) { continue; }

				winPositions[expandPosition.reel].row = expandPosition.row;
			}
		}
	}

	groupWinLines(lines, bet) {
		lines = this.sortWinLines(lines);
		const groups = [];

		class Group {
			positions = null;
			totalWin = 0;
			baseTotalWin = 0;
			multiplier = 1;
			symbolId = null;
			lines = [];
			cheap = false;

			constructor(lines) {
				for (let i = 0; i < lines.length; i++) {
					const line = lines[i];
					this.lines.push(line);

					this.totalWin += line.winAmount;
					this.baseTotalWin += line.baseWinAmount || 0;
					if (line.multipliers && line.multipliers.length) {
						this.multiplier = line.multipliers[0];
					}
				}
				this.positions = this.mergePositions(lines);
				this.symbolId = lines[0].symbol;
				this.cheap = bet >= this.totalWin;
			}

			mergePositions(lines) {
				let positions = [];

				for (let i = 0; i < lines.length; i++) {
					positions.push(...lines[i].positions);
				}

				positions = positions.sort((a, b) => a.reel - b.reel);

				const uniquePositions = [...new Set(positions.map(p => `${p.reel}-${p.row}`))].map(p => {
					const res = {
						reel: +[p[0]],
						row: +[p[2]]
					};

					return res;
				});

				return uniquePositions;
			}
		}

		let prev = [];

		for (let i = 0; i < lines.length; i++) {
			const line = lines[i].data;

			if (!prev.length) {
				prev.push(line);
				continue;
			}
			if (line.symbol === prev[0].symbol) {
				prev.push(line);
				continue;
			}
			groups.push(new Group(prev));
			prev = [];
			prev.push(line);
		}
		if (prev.length) {
			groups.push(new Group(prev));
		}

		return groups;
	}

	sortWinLines(lines) {
		return lines.sort((a, b) => parseInt(b.data.symbol) - parseInt(a.data.symbol));
	}
}

export const winAnimationService = new WinAnimationService();
